<template>
    <div class="authentication">
        <div class="container">
            <div class="row clearfix">
                <div class="col-lg-6 col-md-12">
                    <div class="company_detail">
                        <h4 class="logo">
                            <img class="mr-2" src="@/assets/images/finallogo.png" alt="Logo" />
                            EASY WORK
                        </h4>
                        <h3>
                            업무 능력을 향상 시켜주는 <strong>수월한</strong> 서비스에
                            가입하세요.
                        </h3>
                        <p>
                            자동화 서비스는 반복 작업을 대신 해줌으로 시간을 단축시켜 줍니다.
                        </p>
                        <br />
                        <!-- <div class="col-sm-10"> -->
                        <img
                            class="rounded"
                            src="@/assets/images/signin.jpg"
                            alt="Rounded Image"
                            style="width: 100%"
                        />
                        <!-- </div> -->
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />

                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="card-plain ml-auto">
                        <div class="header">
                            <h5>회원가입</h5>
                        </div>

                        <div class="body">
                            <h6 class="card-inside-title">유저명</h6>
                            <div class="form-group">
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        maxlength="50"
                                        v-model="name"
                                        placeholder="유저명"
                                    />
                                </div>
                            </div>

                            <h6 class="card-inside-title">이메일</h6>
                            <div class="form-group">
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :class="{ 'borderStyleRed' : borderStyle == 0,'borderStyleGreen' : borderStyle == 1 , 'borderStyleRevert' : borderStyle == 2 }"
                                        ref="emailInput"
                                        v-model="email"
                                        maxlength="50"
                                        placeholder="이메일"
                                        @keyup="checkEmail"
                                    />
                                </div>
                            </div>

                            <h6 class="card-inside-title">비밀번호</h6>
                            <div class="form-group">
                                <div class="input-group">
                                    <input
                                        type="password"
                                        class="form-control"
                                        maxlength="50"
                                        v-model="password"
                                        placeholder="비밀번호"
                                    />
                                </div>
                                <span v-if="password != '' && password.length < 8">비밀번호는 8자 이상입니다.</span>
                            </div>
                            <div class="form-group">
                                <div class="input-group">
                                    <input
                                        type="password"
                                        placeholder="비밀번호 확인"
                                        maxlength="50"
                                        v-model="passwordcheck"
                                        class="form-control"
                                    />
                                </div>
                            </div>
                            <div class="mt-4">
                                <label class="c_checkbox">
                                    <input
                                        type="checkbox"
                                        value="personal"
                                        v-model="personalAgree1"
                                        checked=""
                                    />
                                    <span class="checkmark"></span>
                                    <span class="ml-2 font-13">개인정보처리방침 동의</span>
                                    <span class="ml-2 font-13"><router-link to="/privacy">[보기]</router-link></span>
                                </label>
                            </div>
                            <div class="mt-4">
                                <label class="c_checkbox">
                                    <input
                                        type="checkbox"
                                        value="personal"
                                        v-model="personalAgree2"
                                        checked=""
                                    />
                                    <span class="checkmark"></span>
                                    <span class="ml-2 font-13">서비스이용약관 동의</span>
                                    <span class="ml-2 font-13"><router-link to="/service">[보기]</router-link></span>
                                </label>
                            </div>
                        </div>

                        <div class="footer mt-3">
                            <button
                                type="button"
                                class="btn btn-secondary btn-block"
                                @click="register"
                            >
                                가입하기
                            </button>
                        </div>
                        <span
                        >계정이 있으신가요?<button type="button" class="btn btn-default" style="background: none; border: none; color: #0c85e0;" @click="toLogin"> 로그인하기</button></span
                        >
                    </div>
                </div>
            </div>
            <div class="footer">
                <ul class="list-unstyled d-inline-flex mt-2">

                    <li class="mr-3"><router-link to="/service">서비스 이용약관</router-link></li>
                    <li class="mr-3"><router-link to="/privacy">개인정보처리방침</router-link></li>
                    <li class="mr-3"><a href="https://www.easywork.ai" target="_blank">소개</a></li>
                    <li class="mr-3"><router-link to="/plan-setting">플랜</router-link></li>
                </ul>
                <br />
                <br />
                <p class="copyright mb-0">
                                    <span style="line-height: 180%">
                                    주식회사 프렌츠 | 주소 : 서울시 마포구 백범로 31길 8 공덕SK리더스뷰 201동 514호<br />
                                    사업자등록번호 : 742-81-01548 | 통신판매신고번호 : 제2022-서울마포-3846호 | 대표이사 : 김호천 | 고객센터 : 02-2038-8990, support@frients.co.kr<br />

                                    Copyright 2022 © All Rights Reserved.
                                    </span>
                    <a href="http://www.easywork.ai" target="_blank">EASY WORK</a>
                </p>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name: 'SignInPage',
    components: {
    },
    data() {
        return {
            email: "",
            password: "",
            passwordcheck: "",
            name: "",

            personalAgree: [],
            personalAgree1: false,
            personalAgree2: false,

            borderStyle: 2,
            emailCheck: -1,
        }
    },
    methods: {
        toLogin(){
            this.$router.push({name:'LoginPage'})
        },
        register() {
            const emailRegExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

            if (this.personalAgree1 === false) {
                alert("개인정보처리방침에 동의해주세요.");
                return;
            }
            if (this.personalAgree2 === false) {
                alert("서비스이용약관에 동의해주세요.");
                return;
            }
            if (this.password != this.passwordcheck) {
                alert("비밀번호를 확인해주세요.");
                return;
            }
            if(this.password.length < 8){
                alert("비밀번호는 8자 이상입니다.")
                return;
            }
            if (this.emailCheck != 0) {
                alert("이메일을 다시 한번 확인해주세요.");
                return;
            }
            if(this.email.match(emailRegExp) == null) {
                alert("이메일 형식이 아닙니다.")
                return;
            }

            this.api.signIn({
                userEmail: this.email,
                userPw: this.password,
                userName: this.name,
            })
                .then((res)=>{
                    if (res.code == 0) {
                        alert("회원가입에 성공했습니다.");
                        this.$router.push({name:'LoginPage'})
                        // location.href = "/login";
                    } else {
                        alert(
                            "회원가입 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
                        );

                    }
                })

            // axios
            //   .post(
            //     Apiroot.company + Urls.register,
            //
            //     {
            //       userEmail: this.email,
            //       userPw: this.password,
            //       userName: this.name,
            //     },
            //     {
            //       headers: {
            //         "Content-Type": "application/json",
            //       },
            //     }
            //   )
            //   .then((res) => {
            //     if (res.status == 200) {
            //       if (res.data["code"] == 0) {
            //         alert("회원가입에 성공했습니다.");
            //         location.href = "/";
            //       } else {
            //         alert(
            //           "회원가입 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
            //         );
            //       }
            //     }
            //   })
            //   .catch((error) => {
            //     console.log(error);
            //   });
        },

        checkEmail() {
            this.email = this.email.replace(" ", "");

            if (this.email.length > 0) {

                this.api.emailCheck({userEmail: this.email})
                    .then((res)=>{
                        console.log(res)
                        if (res.code == 0) {
                            this.borderStyle = 1;
                            this.emailCheck = res.check;
                            console.log("이메일 중복 아님");
                        } else if(res.code == 10004) {
                            // alert('.')
                            this.borderStyle = 0;
                            this.emailCheck = res.check;
                            console.log("이메일 중복 111");

                        }

                    })
            }
        },
    },
    created() {
        console.log('SignInPage created')

        this.$store.state.userStore.loginSuccess = false;
        this.$store.state.userStore.userEmail = null;
        this.$store.state.userStore.userCode = null;
        this.$store.state.userStore.userName = null;
        this.$store.state.userStore.apiKey = null;
        this.$store.state.userStore.trackingCode = null;

    },
    mounted() {
        console.log('SignInPage created')
    },
    beforeDestroy() {
        console.log('SignInPage beforeDestroy')
    }
}
</script>

<style>
.borderStyleRed{
    border : 1px solid red;
}
.borderStyleGreen{
    border : 1px solid #004b0f;

}
.borderStyleRevert{
    border : 1px solid #bebebe;

}
</style>